import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { apiClient } from '../../utils/axiosAdvanced';
import { toast } from "react-toastify";
import { GENSET_TAMPER_REPORT_TYPE } from '../../utils/reportTypes';

export const history24 = createAsyncThunk(
    'history/history24',
    async ({ assetId, assetName }, thunkAPI) => {
        try {
            const reqData = {
                assetId, assetName,
                timeFrom: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
                timeTo: moment().format('YYYY-MM-DD HH:mm:ss'),
                minStop: 300000,
                minDrive: 1,
                trackType: 'history24',
            };
            //console.log("Track req data", reqData);
            const apiData = await apiClient.post('/buildreport_track', reqData);
            const { submitted, initialSummary } = apiData.data;
            //console.log("History24  API", apiData.data);
            const message = `Building 24 hour track for ${assetName}`;
            //console.log("One 24H track", submitted, initialSummary, result)

            if (submitted) {
                toast.success(message);
                return initialSummary;
            } else {
                return null;
            }
            //return { history: apiData.data.result };
        } catch (error) {
            //console.log("History24 error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const historyCustom = createAsyncThunk(
    'history/historyCustom',
    async ({ timeFrom, timeTo, minStop, minDrive, assets, assetIds }, thunkAPI) => {
        try {
            let respArray = [];
            let index = 0;
            for (const assetId of assetIds) {
                const reqData = {
                    assetId, assetName: assets[index], timeFrom, timeTo, minStop, minDrive,
                    trackType: 'customHistory',
                };
                const apiData = await apiClient.post('/buildreport_track', reqData);
                const { submitted, initialSummary } = apiData.data;
                if (submitted) {
                    respArray.push(initialSummary);
                }
                index++;
            }
            const assetNames = assetIds.length === 1 ? assets[0] : `${assets.length} Vehicles`;
            const message = `Building Custom track report for ${assetNames}`;
            toast.success(message);
            return respArray;
        } catch (error) {
            //console.log("History24 error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const buildReportOne = createAsyncThunk(
    'reports/buildReportOne',
    async ({ assetIds, assets, reportType, minStop, minDrive,
        minActive, hold,
        speedLimit, timeFrom, timeTo, mapNeeded,
        event_desc, crawl, minTemp, maxTemp, interval,
        accurateKm,
        includeEventList, includeAddresses, includeDebug, disableCrawlFallback,
        routeNames, routeNumbers, ruleNames,
        emailPDF, emails
    }, thunkAPI) => {
        try {
            let respArray = [];
            let index = 0;
            for (const assetId of assetIds) {
                const reqData = {
                    assetId, assetName: assets[index], minStop, minDrive,
                    minActive, hold, minTemp, maxTemp, interval,
                    speedLimit, timeFrom, timeTo, mapNeeded,
                    accurateKm,
                    event_desc, crawl, routeNames, routeNumbers, ruleNames,
                    includeEventList, includeAddresses, includeDebug, disableCrawlFallback,
                    emailPDF, emails
                };
                console.log("Build report reqbody", reqData);
                try {
                    const apiData = await apiClient.post(`/buildreport_${reportType.value}`, reqData);
                    const { result, submitted, initialSummary } = apiData.data;
                    if (submitted) {
                        respArray.push(initialSummary);
                    } else {
                        if (result) {
                            toast.error(`${result} for ${reqData.assetName}`);
                        } else {
                            toast.error(`Related Sensor or Data not found for ${reqData.assetName}`);
                        }

                    }
                    index++;
                } catch (error) {
                    console.log("Build report API error", error);
                    return thunkAPI.rejectWithValue(error);
                }
                
            }
            const assetNames = assetIds.length === 1 ? assets[0] : `${assets.length} Vehicles`;
            const message = `Building ${reportType.name} Report for ${assetNames}`;
            toast.success(message);
            return respArray;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)



export const buildReportMulti = createAsyncThunk(
    'reports/buildReportMulti',
    async ({ assetIds, assets, zoneIds, zones,
        reportType, minStop, minDrive, minActive, hold, interval,
        speedLimit, timeFrom, timeTo, mapNeeded,
        emailPDF, emails, crawl, routeNames, routeNumbers, ruleNames,
        includeEventList, includeAddresses, includeDebug, disableCrawlFallback
    }, thunkAPI) => {
        try {
            let reqData = {
                assetIds, assetNames: assets, zoneIds, zoneNames: zones, minStop, minDrive, minActive, hold,
                speedLimit, timeFrom, timeTo, mapNeeded, interval,
                emailPDF, emails, crawl, routeNames, routeNumbers, ruleNames,
                includeEventList, includeAddresses, includeDebug, disableCrawlFallback
            };
            if (reportType.value === GENSET_TAMPER_REPORT_TYPE) {
                reqData = {
                    timeFrom,
                    timeTo,
                    includeAddresses: includeAddresses !== undefined ? includeAddresses : true,
                    includeDebug: Boolean(includeDebug),
                };
            }
            if (reportType.value === GENSET_TAMPER_REPORT_TYPE) {
                reqData.assetIds = assetIds;
                reqData.assetNames = assets;
                reqData.assets = assetIds.map((assetID, index) => ({
                    assetID,
                    assetName: assets[index],
                }));
            }
            console.log("Multi report reqbody", reqData);
            const apiData = await apiClient.post(`/buildreport_${reportType.value}`, reqData);
            const { submitted, initialSummary } = apiData.data;
            const assetNames = assetIds.length === 1 ? assets[0] : `${assets.length} Vehicles`;
            const message = `Building ${reportType.name} Report for ${assetNames}`;

            if (submitted) {
                toast.success(message);
                return initialSummary;
            } else {
                return null;
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const getReportList = createAsyncThunk(
    'reports/getReportList',
    async (_, thunkAPI) => {
        try {
            const apiData = await apiClient.get('/get_reportlist');
            //console.log("Get list", apiData.data);
            //toast.success("Report downloaded");
            return apiData.data.reports;
        } catch (error) {
            //console.log("Get track list error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);


export const downloadTrack = createAsyncThunk(
    'history/downloadTrack',
    async (reportID, thunkAPI) => {
        console.log("Get reportdata", reportID)
        try {
            const apiData = await apiClient.post('/get_reportdata', { reportID });
            toast.success("Track downloaded", apiData.data);
            return { reportID, reportData: JSON.parse(apiData.data.reportData) };
        } catch (error) {
            //console.log("Get reportdata error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const downloadReport = createAsyncThunk(
    'reports/downloadReport',
    async (reportID, thunkAPI) => {
        //console.log("Download report data", reportID)
        try {
            const apiData = await apiClient.post('/get_reportdata', { reportID });
            console.log("Report downloaded", apiData.data);
            return { reportID, reportData: JSON.parse(apiData.data.reportData) };
        } catch (error) {
            //console.log("Get reportdata error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);




export const deleteReport = createAsyncThunk(
    'reports/deleteReport',
    async (reportID, thunkAPI) => {
        try {
            await apiClient.post('/delete_report', { reportID });
            //console.log("delete trackData", apiData.data);
            toast.success("Report Deleted");
            return { reportID };
        } catch (error) {
            //console.log("delete track error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const reportTtl = createAsyncThunk(
    'reports/reportTtl',
    async ({ reportID, hours }, thunkAPI) => {
        try {
            await apiClient.post('/reportttl', { reportID, hours });
            //console.log("ttl trackData", apiData.data);
            toast.success("Track Expiry extended");
            return { reportID };
        } catch (error) {
            //console.log("ttl track error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getExcel = createAsyncThunk(
    'history/getExcel',
    async (reportID, thunkAPI) => {
        //console.log("Get excel", reportID);
        try {
            const apiData = await apiClient.post('get_report_excel', { reportID }, { responseType: 'blob' });
            //console.log("api excel got", apiData);
            const fileName = apiData.headers["content-disposition"].split("filename=")[1];
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                window.navigator.msSaveOrOpenBlob(
                    new Blob(
                        [apiData.data],
                        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
                    ),
                    fileName
                );
            } else {
                const url = window.URL.createObjectURL(
                    new Blob(
                        [apiData.data],
                        {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        }
                    )
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    apiData.headers["content-disposition"].split("filename=")[1]
                );
                document.body.appendChild(link);
                link.click();
            }
            return true;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getPdf = createAsyncThunk(
    'reports/getPdf',
    async (reportID, thunkAPI) => {
        try {
            const apiData = await apiClient.post('download_pdf', { reportID, mapNeeded: true }, { responseType: 'blob' });
            try {
                const fileName = apiData.headers["content-disposition"].split("filename=")[1];
                const url = window.URL.createObjectURL(new Blob([apiData.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            } catch (error) {
                toast.success("PDF download being prepared", { autoClose: 15000 });
            }
            return true;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const emailPdf = createAsyncThunk(
    'reports/emailPdf',
    async ({ reportID, emails, type, mapNeeded }, thunkAPI) => {
        try {
            await apiClient.post('email_pdf', { reportID, emails, type, mapNeeded }, { responseType: 'blob' });
            toast.success("Email request received", { autoClose: 8000 });
            return true;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
